'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  overflow: ", ";\n  text-overflow: ", ";\n  white-space: ", ";\n  padding: ", ";\n"], ["\n  overflow: ", ";\n  text-overflow: ", ";\n  white-space: ", ";\n  padding: ", ";\n"])), function (props) { return (props.nowrap ? 'hidden' : 'normal'); }, function (props) { return (props.nowrap ? 'ellipsis' : 'none'); }, function (props) { return (props.nowrap ? 'nowrap' : 'normal'); }, function (props) { return (props.addPadding ? '0' : '0px 5px'); });
var templateObject_1;

exports.Container = Container;
